import createRoute          from '@widesk-ui/tools/createRoute';
import MessageTemplateModel from '@models/shop/MessageTemplateModel';

export default createRoute.dashboard('/message_templates', 'shop', 'MessageTemplateDashboard', MessageTemplateModel.localize());
